<div class="col-md-3">
  <grouping-side-nav
    [dataConfigs]="aggGroups"
    [selectedDataConfig]="selectedAggGroup"
    (selectNewDataConfig)="selectNewAggGroup($event)"
  >
  </grouping-side-nav>
</div>
<div class="col-md-9">
  <grouping-body
    [selectedDataConfig]="selectedAggGroup"
    (visibilityChanged)="visibilityChanged($event)"
    (goToCurrentGradeLevelEmitter)="goToCurrentGradeLevel()"
  ></grouping-body>
</div>
